<template>
  <div :class="componentClassName">
    <div class="a-vdxb-modal-header__title">
      <div v-if="icon" class="a-vdxb-modal-header__icon">
        <a-vdxb-icon :icon="icon" :color="iconColor" />
      </div>
      <slot>{{ title }}</slot>
    </div>
    <div v-if="showClose" class="a-vdxb-modal-header__close-button">
      <a-vdxb-button variant="icon" icon="close" icon-color="blue" @click="handleClose" />
    </div>
  </div>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import AVdxbButton from '@/components/atoms/vdxb-button';
import AVdxbIcon from '@/components/atoms/vdxb-icon';

export default {
  name: 'a-vdxb-modal-header',
  components: {
    AVdxbButton,
    AVdxbIcon,
  },
  props: {
    class: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    iconColor: {
      type: String,
      default: 'orange',
    },
    withBorder: {
      type: Boolean,
      default: true,
    },
    showClose: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['close'],
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('a-modal-header', this.withBorder ? 'border' : '');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
  methods: {
    handleClose(event) {
      this.$emit('close', event);
    },
  },
};
</script>
